export default [
  "Popular Items",
  "Wings & Tenders",
  "Popcorn Chicken",
  "Mix & Match Combos",
  "Fish & Shrimp",
  "Sandwiches",
  "Drinks",
  "Party Trays",
  "Kid's Menu",
  "Sides",
];
